import { render } from "./LeadsTable.vue?vue&type=template&id=7d943a12"
import script from "./LeadsTable.vue?vue&type=script&lang=js"
export * from "./LeadsTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__